import { createContext } from 'react';

const NotificationContext = createContext({
    message: '',
    visible: false,

    /**
     * Although it is possible to remove the following I like to keep them here
     * because they help anyone importing LoadingThemeContext to understand what API (methods)
     * this particular context has available
     * @param {object} message the message to update
     */
    showMessage: newMessage => { }
});

export default NotificationContext;


// WEBPACK FOOTER //
// ./src/context/notification.Context.js